import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Language } from '../../models/languages/language.model';
import { LanguagesService } from '../../services/languages/languages.service';
import { ApiLanguagesService } from '../../services/languages/api/api-languages.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalsService } from '../../services/modals.service';
import { LanguageAddModalComponent } from './modals/language-add-modal/language-add-modal.component';
import { LanguageEditModalComponent } from './modals/language-edit-modal/language-edit-modal.component';

@Component({
  templateUrl: 'languages.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, TooltipModule, LanguageAddModalComponent, LanguageEditModalComponent]
})
export class LanguagesComponent implements OnInit {

  @ViewChild('addModal') addModal!: LanguageAddModalComponent;
  @ViewChild('editModal') editModal!: LanguageEditModalComponent;

  get languages(): Language[] {
    return this.languagesService.languages;
  }

  constructor(
    public languagesService: LanguagesService,
    private apiLanguagesService: ApiLanguagesService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  ngOnInit(): void {
    this.refreshLanguages();
  }

  onClickAdd(): void {
    this.addModal.show(() => this.refreshLanguages());
  }

  onClickEdit(language: Language): void {
    this.editModal.show(language.languageId, language.languageIso, () => this.refreshLanguages());
  }

  onClickToggleActive(language: Language): void {
    this.apiLanguagesService.changeLanguageActiveState(language.languageId, !language.isActive).then(
      () => {
        language.isActive = !language.isActive;
      }, error => {
        this.alertsService.displayAlertError('Error updating language state : ' + error);
      }
    );
  }

  onClickDelete(language: Language): void {
    this.modalsService.showConfirmModal(() => {
      this.apiLanguagesService.deleteLanguage(language.languageId).then(
        () => {
          this.alertsService.displayAlertSuccess('Language deleted !');
          this.refreshLanguages();
        }, error => {
          this.alertsService.displayAlertError('Error deleting language : ' + error);
        }
      );
    });
  }

  private refreshLanguages(): void {
    this.apiLanguagesService.getLanguages().then(
      response => {
        this.languagesService.languages = response.results;
      }, error => {
        this.alertsService.displayAlertError('Error loading languages : ' + error);
      }
    );
  }
}
